import api from '@/api'

interface JoinOrg {
  suscess: boolean
  data: {
    org_id: string
  }
  message: string
}

export async function joinOrganization(invite_id: string): Promise<JoinOrg> {
  const res = await api.post(`/college/org/invites/${invite_id}/accept`)
  return res.data
}

interface PublicInvite {
  status: string
  data: {
    org_name: string
    org_logo: string
    role: string
  }
}

export async function getInvitePublicDetails(
  invite_id: string
): Promise<PublicInvite> {
  const res = await api.get(`/college/org/invites/${invite_id}/public`)
  return res.data
}
export async function RejectOrganization(invite_id: string) {
  const res = await api.post(
    `/college/org/invites/${invite_id}/revoke?revoked_by=external`
  )
  return res.data
}

interface Invite {
  data: {
    org_id: string
    id: string
    org_name: string
    role: string
  }[]
  success: boolean
}

export async function getMyInvites(): Promise<Invite> {
  const res = await api.get('/college/org/invites')
  return res.data
}

interface UserDetails {
  data: {
    exists: boolean
    data: {
      name: string
      email: string
      role: string
    }
  }
}

export async function getUserDetails(uid: string): Promise<UserDetails> {
  const res = await api.get(`/college/user/profile/${uid}`)
  return res.data
}
